import Api from 'src/api/Base'

class GetRoles extends Api {
  requestUrl = `/api/role`
}

export default GetRoles
